import React from 'react'
import { BoxProps, Flex } from '@chakra-ui/react'

import { ItemCardStylingProps } from '../../interfaces'
import { ItemCardIconWrapper, ItemCardText } from '../../styles'

type Props = {
  luIcon: JSX.Element
} & ItemCardStylingProps &
  BoxProps

export const ItemCardListItem: React.FC<Props> = ({ luIcon, children, isBundle, ...boxProps }) => {
  const stylingProps: ItemCardStylingProps = { isBundle }
  return (
    <Flex alignItems="center" marginBottom="5px">
      <ItemCardIconWrapper {...stylingProps}>{luIcon}</ItemCardIconWrapper>
      <ItemCardText {...stylingProps} fontSize="sm" {...boxProps}>
        {children}
      </ItemCardText>
    </Flex>
  )
}
